class SelectElement extends HTMLElement {
  #button = this.querySelector('[aria-controls]');
  #list = this.#button?.ariaControlsElements?.[0];
  #hiddenInput = this.querySelector('[data-select-input]');
  #options = this.#list?.querySelectorAll('[data-value]');
  #handleListClick = (event) => this.#selectOption(event);
  #observer;

  connectedCallback() {
    if (!this.#button || !this.#list || !this.#hiddenInput) return;

    document.body.appendChild(this.#list);
    this.#list.ariaHidden = this.ariaHidden;
    this.#list.addEventListener('click', this.#handleListClick);

    // Keep dropdown visibility in sync with the controller element.
    this.#observer = new MutationObserver(() => {
      this.#list.ariaHidden = this.ariaHidden;
    });
    this.#observer.observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });

    this.initSelectedOption();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    if (!this.#list) return;

    this.#list.removeEventListener('click', this.#handleListClick);
    this.#list.remove();
  }

  initSelectedOption() {
    let selectedOption = this.#list?.querySelector('[data-selected]');

    if (!selectedOption && this.#hiddenInput?.value) {
      selectedOption = Array.from(this.#options || []).find(
        (option) => option.dataset.value === this.#hiddenInput.value
      );
    }

    if (!selectedOption) return;

    selectedOption.setAttribute('data-selected', '');
    this.#updateButtonContent(selectedOption);
    this.#hiddenInput.value = selectedOption.dataset.value;
  }

  #updateButtonContent(optionElement) {
    if (!optionElement) return;
    this.#button.innerHTML = optionElement.cloneNode(true).innerHTML;
  }

  /**
   * @param {MouseEvent} event - The event that triggered the selection
   */
  #selectOption({ target }) {
    const option = target.closest('[data-value]');
    if (!option) return;

    this.#options?.forEach((item) => item.removeAttribute('data-selected'));
    option.setAttribute('data-selected', '');
    this.#updateButtonContent(option);

    this.#hiddenInput.value = option.dataset.value;
    this.#hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('select-element', SelectElement);
